<template>
  <div class="ui styled fluid accordion">
    <template v-for="(item, key) in $t('faqContent.accordion')">
      <template v-if="key !== 'patients' && key !=='employer'">
        <div
          :key="`title-${key}`"
          class="title"
          style="font-size: 1.285714rem;">
          <i class="dropdown icon"/>
          {{ item.header }}
        </div>
        <div
          :key="`content-${key}`"
          class="content"
          style="margin-left: 1.42857rem;">
          <div
            v-for="(paragraph, index) in Object.values(item.content)"
            :key="index">
            <p
              class="transition visible"
              v-html="paragraph"
              v-if="typeof paragraph !== 'object'"
              style="margin-bottom: 15px !important;"/>
            <p
              class="transition visible"
              style="margin-bottom: 15px !important;"
              v-html="paragraph.videoHeader"
              v-if="typeof paragraph === 'object'"/>
            <div
              class="embed-container"
              v-if="paragraph.dataSource && paragraph.dataId">
              <div
                class="ui embed"
                :data-source="paragraph.dataSource"
                :data-id="paragraph.dataId"/>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {
    $('.ui.accordion')
      .accordion({ exclusive: false })
      .accordion()
    $('.ui.embed').embed()
  }
}
</script>

<style scoped>
.embed-container {
  width: 60%;
  margin-bottom: 20px;
}
@media screen and (max-width: 767px) {
  .embed-container {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
